export default __webpack_public_path__ + "static/skipgap-e9dc519c3c9835a25eb35e5f0abde494.png";